import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { store } from './store';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import Sidebar from "../components/Sidebar";
import ProtectedRoute from "../components/ProtectedRoute";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PrecheckAuthRoute from "../components/PrecheckAuthRoute";
import { RoutePages } from "../ultils";

export default function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="relative flex">
          <Sidebar />
          {/* Responsive main content: margin-left for desktop, none for mobile */}
          <div className="w-full min-h-screen flex flex-col transition-all duration-200"
            style={{ minHeight: "100vh" }}
          >
            <Header />
            <main
              className="
                mt-16 flex-1
                ml-0 md:ml-16
                px-0 sm:px-2
                transition-all duration-200
              "
            >
              <Routes>
                <Route {...RoutePages.HOME} />
                <Route element={<PrecheckAuthRoute />}>
                  <Route {...RoutePages.AUTH} />
                  <Route {...RoutePages.FORGOTTEN_PASSWORD} />
                  <Route {...RoutePages.API_STATUS} />
                  <Route {...RoutePages.PRICING.FB_GRAPH} />
                  <Route {...RoutePages.PRICING.TIKTOK} />
                  <Route {...RoutePages.PRICING.FB_ACTION} />
                  <Route {...RoutePages.DOCS.FB_GRAPH} />
                  <Route {...RoutePages.DOCS.TIKTOK} />
                  <Route {...RoutePages.DOCS.FB_ACTION} />
                </Route>
                <Route element={<ProtectedRoute />}>
                  <Route {...RoutePages.ADMIN} />
                  <Route {...RoutePages.MY_SUBSCRIPTIONS} />
                  <Route {...RoutePages.USER} />
                </Route>
              </Routes>
            </main>
            <Footer />
          </div>
        </div>
      </Router>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </Provider>
  );
}
